import { render, staticRenderFns } from "./wishlist-component.vue?vue&type=template&id=b060e7b0&scoped=true&"
import script from "./wishlist-component.vue?vue&type=script&lang=js&"
export * from "./wishlist-component.vue?vue&type=script&lang=js&"
import style0 from "./wishlist-component.vue?vue&type=style&index=0&id=b060e7b0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b060e7b0",
  null
  
)

export default component.exports